import { connect } from 'react-redux';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { MY_COMMENTS_STREAM } from '../../../streams';
import { AppState } from '../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerStat,
  getProfileOwnerUser,
} from '../../../selectors/users';

export default connect(
  (state: AppState) => {
    const items = streamSelectors.getItems(state, MY_COMMENTS_STREAM);
    const totalSent = getProfileOwnerStat(state, 'commentsMade');
    return {
      items,
      totalSent,
      hasMore: streamSelectors.hasMore(state, MY_COMMENTS_STREAM),
      isFetching: streamSelectors.isFetching(state, MY_COMMENTS_STREAM),
      isEmpty: !items.length,
      isOwner: isCurrentUserProfileOwner(state),
      profileOwnerUser: getProfileOwnerUser(state),
    };
  },
  dispatch => ({
    fetchMore: () => dispatch(withOffset.actions.fetch(MY_COMMENTS_STREAM)),
  })
);
